export default __webpack_public_path__ + "static/media/one.f4599468.svg";